import { LoadingPage, Page, Typography } from "@fideus-ui/core";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useQuery, useTRPC } from "../_app/api";
import { useTranslation } from "../_app/i18n";
import { translations } from "./-translations";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  const t = useTranslation(translations);
  const trpc = useTRPC();
  const navigate = useNavigate();

  // Call me to ensure the user is auto-created in the database
  const { data: meData } = useQuery(trpc.me.queryOptions());

  const { data: taxAdvisories, isLoading } = useQuery(
    trpc.taxAdvisories.listMyTaxAdvisories.queryOptions(undefined, {
      refetchInterval: 3_000,
    })
  );

  useEffect(() => {
    const singleAdvisory = taxAdvisories?.[0];
    if (taxAdvisories?.length === 1 && singleAdvisory) {
      navigate({
        to: "/beratung/$taxAdvisoryId/unternehmen",
        params: { taxAdvisoryId: singleAdvisory.id },
      });
    }
  }, [taxAdvisories, navigate]);

  if (meData && "status" in meData) {
    return (
      <Page>
        <Typography variant="h4" gutterBottom>
          {t("ssoRequired")}
        </Typography>
        <Typography>{t("ssoMessage")}</Typography>
      </Page>
    );
  }

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!taxAdvisories || taxAdvisories.length === 0) {
    return (
      <Page>
        <Typography variant="h4" gutterBottom>
          {t("noAdvisory")}
        </Typography>
        <Typography>{t("noAdvisoryMessage")}</Typography>
      </Page>
    );
  }

  if (taxAdvisories.length > 1) {
    return (
      <Page>
        <Typography variant="h4" gutterBottom>
          {t("multipleAdvisories")}
        </Typography>
        <Typography>{t("multipleAdvisoriesMessage")}</Typography>
      </Page>
    );
  }

  // Will redirect in useEffect
  return <LoadingPage />;
}
